var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "errors": _vm.errors,
      "defaultValues": _vm.defaultValues,
      "readonly": _vm.isRequestCreating
    },
    on: {
      "submit": _vm.handleSubmit
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(api) {
        return [_c('v-stepper-content', [_c('v-row', [_c('v-col', {
          attrs: {
            "xs": "6"
          }
        }, [_c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "lastName",
            "label": "Фамилия",
            "required": true,
            "readonly": true
          }
        }), _vm._v(" "), _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "firstName",
            "label": "Имя",
            "required": true,
            "readonly": true
          }
        }), _vm._v(" "), _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "middleName",
            "label": "Отчество",
            "required": false,
            "readonly": true
          }
        }), _vm._v(" "), _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "dateBirth",
            "label": "Дата рождения",
            "required": true,
            "readonly": true,
            "caption": "ДД / ММ / ГГГГ",
            "mask": "date"
          }
        }), _vm._v(" "), _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "documentSeries",
            "label": "Паспорт серия",
            "required": true,
            "readonly": true
          }
        }), _vm._v(" "), _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "documentNumber",
            "label": "Паспорт номер",
            "required": true,
            "readonly": true
          }
        }), _vm._v(" "), _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "monitoringEndDate",
            "required": true,
            "label": "Дата окончания мониторинга",
            "caption": "ММ/ГГГГ",
            "mask": "dateWithoutDay",
            "placeholder": _vm.placeholderDate
          },
          on: {
            "input": _vm.onMonitoringDateChange
          }
        }), _vm._v(" "), (_vm.monitoringDateError) ? _c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "error-message"
        }, [_c('v-text', {
          staticStyle: {
            "color": "#ff4444"
          },
          attrs: {
            "error": "",
            "type": "caption"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.monitoringDateError) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }]
        }, [_c('v-text', {
          attrs: {
            "type": "caption"
          }
        }, [_vm._v("\n                  Мониторинг действует по конец выбранного месяца включительно.\n                ")])], 1), _vm._v(" "), _c('v-form-checkbox', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "data": "true",
            "field": "agreementReceived",
            "required": true
          },
          scopedSlots: _vm._u([{
            key: "label",
            fn: function(label) {
              return [_c('v-text', [_vm._v(" Получено согласие субъекта на обработку его перс. данных. ")])]
            }
          }])
        }), _vm._v(" "), _c('v-spinner', {
          attrs: {
            "active": _vm.isRequestCreating
          }
        }, [_c('v-button', {
          attrs: {
            "type": "submit",
            "primary": "",
            "disabled": api.isInvalid || _vm.isRequestCreating || !_vm.isFormValid
          }
        }, [_vm._v("\n                  Продлить мониторинг\n                ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-label', {
          attrs: {
            "icon": "error"
          }
        }, [_c('v-text', {
          attrs: {
            "type": "subheadling"
          }
        }, [_vm._v(" Итого: " + _vm._s(_vm.calculatedTotal) + " руб ")])], 1), _vm._v(" "), (_vm.isBackendError) ? _c('v-stepper-label', {
          attrs: {
            "icon": "warning",
            "danger": true
          }
        }, [_c('v-text', {
          attrs: {
            "type": "caption",
            "danger": true
          }
        }, [_vm._v(" " + _vm._s(_vm.backendErrorMessage) + " ")])], 1) : _vm._e()]
      }
    }])
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65454eba","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/renewalMonitoring/RenewalMonitoring.vue
// module id = 1095
// module chunks = 0